import { FleetIncidentTotalsScreen } from "@src/features/patriot-tools";

export default FleetIncidentTotalsScreen;
